import { applyMiddleware, createStore } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import thunk from 'redux-thunk';
import storage from 'redux-persist/lib/storage';
import reducers from '../reducers';
import whitelist from './whitelist';
const persistConfig = {
    key: 'root',
    storage,
    whitelist,
};
// eslint-disable-next-line import/no-mutable-exports
let store;
let persistor;
const persistedReducer = persistReducer(persistConfig, reducers);
export default function configureStore(preloadedState = {}) {
    store = createStore(persistedReducer, preloadedState, applyMiddleware(thunk));
    persistor = persistStore(store);
    return {
        store,
        persistor,
    };
}
export { store, persistStore };
